module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0742b_logo_200x200.5e1e3399.png";